import React, { useEffect, useState } from "react";
import "../styles/Statistici.css";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const Statistici = () => {
  const [loading, setLoading] = useState(true);
  const [total, setTotal] = useState(0);
  const [da, setDa] = useState(0);
  const [nu, setNu] = useState(0);
  const [danu, setDanu] = useState(0);

  useEffect(() => {
    fetch("https://tj.marenergy.ro/api.php?action=get_statistici_ctrenergie")
      .then((res) => res.json())
      .then((data) => {
        setTotal(data.total || 0);
        setDa(data.da || 0);
        setNu(data.nu || 0);
        setDanu(data.danu || 0);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Eroare la extragerea statisticilor:", err);
        setLoading(false);
      });
  }, []);

  const fetchAndDownloadExcel = (tip) => {
    fetch(`https://tj.marenergy.ro/api.php?action=export_ctrenergie_${tip}`)
      .then((res) => res.json())
      .then((data) => {
        // 1️⃣ Header tabel + date
        const headers = [["Nr. Crt", "Nume", "Adresă", "Telefon"]];
        const rows = data.map(item => [
          item["Nr. Crt"],
          item["Nume"],
          item["Adresă"],
          item["Telefon"]
        ]);
  
        const worksheet = XLSX.utils.aoa_to_sheet([...headers, ...rows]);
  
        // 2️⃣ Opțional: definire zona de tabel pentru formatare în Excel (AutoFilter + Sort)
        worksheet["!autofilter"] = { ref: `A1:D${data.length + 1}` };
  
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Export");
  
        const fileName = `Statistici_Contracte_${tip.toUpperCase()}.xlsx`;
        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
  
        saveAs(blob, fileName);
      })
      .catch((err) => {
        console.error("Eroare la export:", err);
        alert("Eroare la exportul Excel!");
      });
  };
  
  const downloadFaraInternet = () => {
    fetch("https://tj.marenergy.ro/api.php?action=export_clients_internet_nu")
      .then((res) => res.json())
      .then((data) => {
        const headers = [["Nr. Crt", "Nume", "Adresa", "Telefon"]];
        const rows = data.map(item => [
          item["Nr. Crt"],
          item["Nume"],
          item["Adresa"],
          item["Telefon"]
        ]);
  
        const worksheet = XLSX.utils.aoa_to_sheet([...headers, ...rows]);
        worksheet["!autofilter"] = { ref: `A1:D${data.length + 1}` };
  
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Fara Internet");
  
        const fileName = "Clienti_Fara_Internet.xlsx";
        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
  
        saveAs(blob, fileName);
      })
      .catch((err) => {
        console.error("Eroare la export:", err);
        alert("Eroare la exportul Excel!");
      });
  };

  const downloadTipAcoperisExcel = () => {
    fetch("https://tj.marenergy.ro/api.php?action=export_tip_acoperis")
      .then((res) => res.json())
      .then((data) => {
        const filtered = data; // deja sunt filtrati in PHP
  
        let countTabla = 0;
        let countTigla = 0;
        let countAmbele = 0;
        let countAltele = 0;
  
        const rows = filtered.map((item, index) => {
          const tip = (item.acoperis || "").trim().toLowerCase();
          let clasificare = "";
  
          if (tip.includes("tabla") && tip.includes("tigla")) {
            countAmbele++;
            clasificare = "Ambele";
          } else if (tip.includes("tabla")) {
            countTabla++;
            clasificare = "Tabla";
          } else if (tip.includes("tigla")) {
            countTigla++;
            clasificare = "Tigla";
          } else {
            countAltele++;
            clasificare = "Alt tip";
          }
  
          const telefoane = [];
          if (item.phone) telefoane.push(item.phone);
          if (item.secondaryPhone) telefoane.push(item.secondaryPhone);
  
          return [
            index + 1,
            item.name || "",
            item.address || "",
            telefoane.join(" / "),
            item.acoperis || "",
            clasificare
          ];
        });
  
        const headers = [["Nr. Crt", "Nume", "Adresa", "Telefon", "Acoperis", "Clasificare"]];
        const rezumat = [
          ["Total Tabla", countTabla],
          ["Total Tigla", countTigla],
          ["Total Ambele", countAmbele],
          ["Total Altele", countAltele],
          []
        ];
  
        const worksheet = XLSX.utils.aoa_to_sheet([...rezumat, ...headers, ...rows]);
        worksheet["!autofilter"] = { ref: `A5:F${rows.length + 5}` };
  
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Tip Acoperis");
  
        const fileName = "Statistici_Tip_Acoperis.xlsx";
        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
  
        saveAs(blob, fileName);
      })
      .catch((err) => {
        console.error("Eroare la export tip acoperis:", err);
        alert("Eroare la exportul Excel pentru acoperis!");
      });
  };
  
  const downloadTipBransamentExcel = () => {
    fetch("https://tj.marenergy.ro/api.php?action=export_tip_bransament")
      .then((res) => res.json())
      .then((data) => {
        let countMono = 0;
        let countTri = 0;
        let countNecunoscut = 0;
  
        const rows = data.map((item, index) => {
          const tip = (item.bransament || "").trim().toLowerCase();
          let clasificare = "";
  
          if (tip === "monofazat") {
            countMono++;
            clasificare = "Monofazat";
          } else if (tip === "trifazat") {
            countTri++;
            clasificare = "Trifazat";
          } else {
            countNecunoscut++;
            clasificare = "Necunoscut";
          }
  
          return [
            index + 1,
            item.name || "",
            item.address || "",
            item.phone || "",
            item.bransament || "",
            clasificare
          ];
        });
  
        const headers = [["Nr. Crt", "Nume", "Adresa", "Telefon", "Bransament", "Clasificare"]];
        const rezumat = [
          ["Total Monofazat", countMono],
          ["Total Trifazat", countTri],
          ["Total Necunoscut", countNecunoscut],
          []
        ];
  
        const worksheet = XLSX.utils.aoa_to_sheet([...rezumat, ...headers, ...rows]);
        worksheet["!autofilter"] = { ref: `A5:F${rows.length + 5}` };
  
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Tip Bransament");
  
        const fileName = "Statistici_Tip_Bransament.xlsx";
        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
  
        saveAs(blob, fileName);
      })
      .catch((err) => {
        console.error("Eroare la export bransament:", err);
        alert("Eroare la exportul Excel pentru bransament!");
      });
  };
  
  const downloadTipTablouExcel = () => {
    fetch("https://tj.marenergy.ro/api.php?action=export_tip_tablou")
      .then((res) => res.json())
      .then((data) => {
        let countBusoane = 0;
        let countSigurante = 0;
        let countNecunoscut = 0;
  
        const rows = data.map((item, index) => {
          const tip = (item["Clasificare"] || "").toLowerCase();
          if (tip === "busoane") countBusoane++;
          else if (tip === "sigurante") countSigurante++;
          else countNecunoscut++;
  
          return [
            index + 1,
            item["Nume"],
            item["Adresa"],
            item["Telefon"],
            item["Tip Tablou"],
            item["Clasificare"]
          ];
        });
  
        const headers = [["Nr. Crt", "Nume", "Adresa", "Telefon", "Tip Tablou", "Clasificare"]];
        const rezumat = [
          ["Total Busoane", countBusoane],
          ["Total Sigurante", countSigurante],
          ["Total Necunoscut", countNecunoscut],
          []
        ];
  
        const worksheet = XLSX.utils.aoa_to_sheet([...rezumat, ...headers, ...rows]);
        worksheet["!autofilter"] = { ref: `A5:F${rows.length + 5}` };
  
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Tip Tablou");
  
        const fileName = "Statistici_Tip_Tablou.xlsx";
        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
  
        saveAs(blob, fileName);
      })
      .catch((err) => {
        console.error("Eroare la export tip tablou:", err);
        alert("Eroare la exportul Excel pentru tip tablou!");
      });
  };  

  if (loading) return <div className="energy-stats-wrapper">Se încarcă...</div>;

  return (
    <div className="energy-stats-wrapper">
      <h1>Statistici Contracte Energie</h1>

      <div className="energy-stats-card energy-total">
        <h2>Total completari:</h2>
        <p>{total} clienti</p>
      </div>

      <div className="energy-stats-card energy-da">
        <h2>Contracte pe numele beneficiarului:</h2>
        <p>{da} clienti</p>
        <button className="export-btn" onClick={() => fetchAndDownloadExcel("da")}>📥 Exporta Excel</button>
      </div>

      <div className="energy-stats-card energy-nu">
        <h2>Fara contracte pe numele beneficiarului:</h2>
        <p>{nu} clienti</p>
        <button className="export-btn" onClick={() => fetchAndDownloadExcel("nu")}>📥 Exporta Excel</button>
      </div>

      <div className="energy-stats-card energy-danu">
        <h2>Contracte pe numele beneficiarilor dar pierdute:</h2>
        <p>{danu} clienti</p>
        <button className="export-btn" onClick={() => fetchAndDownloadExcel("danu")}>📥 Exporta Excel</button>
      </div>

      <div className="energy-stats-card energy-nu">
        <h2>Clienti fara Internet:</h2>
        <p>Exporta lista clientilor cu internet = NU</p>
        <button className="export-btn" onClick={downloadFaraInternet}>📥 Exporta Excel</button>
      </div>

      <div className="energy-stats-card energy-total">
        <h2>Tipuri Acoperis:</h2>
        <p>Exporta tabelul cu tipurile de acoperiș (tabla / tigla / altele)</p>
        <button className="export-btn" onClick={downloadTipAcoperisExcel}>📥 Exporta Excel</button>
      </div>

      <div className="energy-stats-card energy-total">
        <h2>Tip Bransament:</h2>
        <p>Exporta tabelul cu bransamente monofazat / trifazat</p>
        <button className="export-btn" onClick={downloadTipBransamentExcel}>📥 Exporta Excel</button>
      </div>

      <div className="energy-stats-card energy-total">
        <h2>Tip Tablou:</h2>
        <p>Exporta clientii pe baza tipului de tablou electric</p>
        <button className="export-btn" onClick={downloadTipTablouExcel}>📥 Exporta Excel</button>
      </div>

    </div>
  );
};

export default Statistici;